//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      fullname: '',
      email: '',
      password: ''
    };
  },
  methods: {
    formSubmit: function formSubmit() {
      console.log('register');
      this.$router.push('/');
    }
  }
};